import { FC, useMemo } from "react";
import { useAppSelector } from "@/store/hooks";
import { overviewLoadingSelector } from "@/store/commitments/selectors/overview/loading/overviewLoadingSelector";
import { money } from "@/utils/numeral/money";
import { CommitmentsPageHeaderMetadataCard } from "@/components/pages/commtiments/common/components/metadata-card/CommitmentsPageHeaderMetadataCard";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { commitmentsDatesSelector } from "@/store/commitments/selectors/common/view-options/commitmentsDatesSelector";
import { generateFromToFromDates } from "@/components/pages/commtiments/utilization-and-coverage/utils/helpers/generateFromToFromDates";
import { overviewTotalNotCoveredSelector } from "@/store/commitments/selectors/overview/overviewTotalNotCoveredSelector";

export const CommitmentsOverviewCoverageMetadataNotCoveredCard: FC = () => {
  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );
  const dates = useAppSelector(commitmentsDatesSelector);
  const datesFromTo = useMemo(() => {
    return generateFromToFromDates(dates, quarterStartMonth);
  }, [dates, quarterStartMonth]);

  const totalNotCovered = useAppSelector(overviewTotalNotCoveredSelector);

  const loading = useAppSelector(overviewLoadingSelector);

  return (
    <CommitmentsPageHeaderMetadataCard
      primary="Not Covered"
      loading={loading}
      value={totalNotCovered === null ? "N/A" : money(totalNotCovered)}
      tooltip={`On-Demand spend of resources not covered by Commitments for date range ${datesFromTo}`}
      descriptionText="Uncovered costs (RI & SP combined)"
    />
  );
};
